import { useTranslations } from "next-intl";

/** H3: covers the paused player when the account plays a video on another device. */
export function PlayingElsewhereOverlay({ onPlayHere }: { onPlayHere: () => void }) {
  const t = useTranslations("player");
  return (
    <div
      role="status"
      className="absolute inset-0 z-20 flex flex-col items-center justify-center gap-3 bg-black/75 p-4 text-center text-white"
      data-testid="player-playing-elsewhere"
    >
      <p className="text-base font-semibold">{t("playingElsewhere")}</p>
      <p className="max-w-sm text-sm text-white/80">{t("playingElsewhereHint")}</p>
      <button
        type="button"
        onClick={onPlayHere}
        className="rounded-md bg-white px-4 py-2 text-sm font-medium text-black hover:bg-white/90 focus-visible:outline focus-visible:outline-2 focus-visible:outline-white"
        data-testid="player-play-here"
      >
        {t("playHere")}
      </button>
    </div>
  );
}
